import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ReplaySubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { INode } from '../../../../shared/models/node.model'
import { NodeItemAnalytics, NodeAnalytics } from '../../../collections/functions/analytics'

export interface NodeListItemComponentProps {
  readonly node: Pick<INode, 'id' | 'title' | 'slug_uri' | 'asset'>
  readonly analyticsProps: NodeItemAnalytics
}

export const getNodeListItemComponentProps = (node: NodeAnalytics): NodeListItemComponentProps => ({
  node: {
    id: node.id,
    title: node.title,
    slug_uri: node.slug_uri,
    asset: node.asset
  },
  analyticsProps: node.analyticProps
})

@Component({
  selector: 'flo-node-list-item',
  template: `
    <li *ngIf="node$ | async as node" class="mx-0 w-100 list-unstyled">
      <a
        [routerLink]="node.slug_uri"
        data-test="node-list-item-link"
        floAnalytics
        tagName="Link"
        [analyticsProperties]="analytics$ | async"
      >
        <flo-medium-content [item]="node" [title]="node?.title" [thumbnail]="true" [desc]="true"> </flo-medium-content>
      </a>
    </li>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodeListItemComponent {
  private readonly props$ = new ReplaySubject<NodeListItemComponentProps>(1)

  @Input()
  set props(props: NodeListItemComponentProps) {
    if (!!props) {
      this.props$.next(props)
    }
  }

  public readonly node$ = this.props$.pipe(map(props => props.node))

  public readonly analytics$ = this.props$.pipe(map(props => props.analyticsProps))
}
